module.exports = __webpack_public_path__ + "img/149.86bff87f.jpg";